var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.477 0 0 4.477 0 10C0 11.89 0.525 13.66 1.438 15.168L0.546 18.2C0.494785 18.3741 0.491415 18.5587 0.536244 18.7346C0.581074 18.9104 0.672448 19.0709 0.800759 19.1992C0.929071 19.3276 1.08958 19.4189 1.26542 19.4638C1.44125 19.5086 1.62592 19.5052 1.8 19.454L4.832 18.562C6.39074 19.5049 8.17824 20.0023 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM7.738 12.263C9.761 14.285 11.692 14.552 12.374 14.577C13.411 14.615 14.421 13.823 14.814 12.904C14.8632 12.7896 14.881 12.6641 14.8655 12.5405C14.85 12.417 14.8019 12.2998 14.726 12.201C14.178 11.501 13.437 10.998 12.713 10.498C12.5619 10.3932 12.3761 10.3512 12.1946 10.3806C12.0131 10.4101 11.8502 10.5088 11.74 10.656L11.14 11.571C11.1083 11.62 11.0591 11.6551 11.0025 11.6692C10.9459 11.6833 10.886 11.6754 10.835 11.647C10.428 11.414 9.835 11.018 9.409 10.592C8.983 10.166 8.611 9.6 8.402 9.219C8.37672 9.17046 8.36957 9.11449 8.38185 9.06115C8.39413 9.00781 8.42503 8.9606 8.469 8.928L9.393 8.242C9.52525 8.12759 9.61063 7.96841 9.63277 7.79495C9.65491 7.62149 9.61226 7.44596 9.513 7.302C9.065 6.646 8.543 5.812 7.786 5.259C7.6881 5.18866 7.57369 5.14479 7.45385 5.13165C7.33402 5.11851 7.21282 5.13654 7.102 5.184C6.182 5.578 5.386 6.588 5.424 7.627C5.449 8.309 5.716 10.24 7.738 12.263Z",
    fill: "#76A140"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.bfc398e755fac059c476f87fad0ab35c.svg";
export { ForwardRef as ReactComponent };